import ReCAPTCHA, { ReCAPTCHAProps } from "react-google-recaptcha"

export function Captcha({ ...props }) {
  const ReCAPTCHAComponent = ReCAPTCHA as unknown as React.FC<ReCAPTCHAProps>

  const onChange = (value: any) => {
    props.set(value)
  }

  return (
    <>
      <ReCAPTCHAComponent size="normal" sitekey="6LdYIO4qAAAAAJyw8cvwNSlp387_TiUGwA5PySBM" onChange={onChange} />
    </>
  )
}
